import { TextArea } from "../FormElements";

export const GraphicEditor = ({ cue, onUpdate }) => {
	return (
		<>
			<TextArea
				label="Paste lyrics "
				value={cue.body}
				rows={2}
				placeholder="These will be automatically converted to clickable lyrics below."
				onChange={(value) => {
					onUpdate({
						body: value,
						lyrics: value
							.split("\n")
							.map((n) => (n)),
						// .filter((n) => n),
						currentLyric: 0,
					});
				}}
			/>
			<span className=" text-gray-500 tracking-wide font-semibold text-xs">
				Lyrics
			</span>
			<ul className="flex flex-col space-y-1 text-sm">
				{cue?.lyrics?.map((lyric, index) => {
					return (
						<button
							className="p-1 h-6 text-left hover:bg-gray-900 focus:outline-none focus:ring rounded"
							onClick={() =>
								onUpdate({
									currentLyric: index,
									current_lyric_text: cue.lyrics?.[index],
								})
							}
						>
							<span className="text-gray-500">
								{cue.currentLyric === index && "→"}
							</span>
							<span className="text-gray-300 whitespace-nowrap">
								{lyric || (
									<span className="text-gray-600 italic">Blank line</span>
								)}
							</span>
						</button>
					);
				})}
			</ul>
		</>
	);
};

export const GraphicCueContent = ({
	cue,
	dynamicText,
	dynamicLists,
	twoLines,
}) => {
	return (
		<div
			className={`overflow-ellipsis w-48 md:w-auto max-w-xs md:max-w-sm lg:max-w-lg overflow-hidden
        ${twoLines ? "whitespace-normal max-h-10" : "whitespace-nowrap"}
        `}
		>
			<span className="font-semibold">
				<span>{cue.lyrics?.[cue.currentLyric]}</span>
				<span className="pl-2 text-sm text-gray-600">
					{cue.lyrics?.[cue.currentLyric + 1]}
				</span>
			</span>
		</div>
	);
};
